"use strict";
/* @flow */

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_1 = __importDefault(require("./config"));

function pay(oauth, options) {
  var _config_1$default = config_1.default(options),
      AUTH_ENDPOINT = _config_1$default.AUTH_ENDPOINT,
      PAY_ENDPOINT = _config_1$default.PAY_ENDPOINT;

  function generateAccountCreationLink(shopId, deviceId) {
    return "".concat(AUTH_ENDPOINT, "/authorize?shop_id=").concat(shopId, "&device_id=").concat(deviceId, "&redirect_uri=").concat(PAY_ENDPOINT, "/account/authorize");
  }

  function createCheckout(body) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a, request, response, results;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                request = {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat((_a = oauth) === null || _a === void 0 ? void 0 : _a.accessToken)
                  },
                  body: JSON.stringify(body)
                }; // @ts-ignore

                _context.next = 4;
                return fetch("".concat(PAY_ENDPOINT, "/checkout"), request);

              case 4:
                response = _context.sent;

                if (!response.ok) {
                  _context.next = 12;
                  break;
                }

                _context.next = 8;
                return response.json();

              case 8:
                results = _context.sent;
                resolve({
                  redirect_uri: results.redirect_uri
                });
                _context.next = 13;
                break;

              case 12:
                reject();

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }));
    });
  }

  function findCheckoutByUuid(uuid, shopId) {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var request, response, results;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                request = {
                  method: 'get',
                  headers: {
                    'x-shop-id': shopId
                  }
                };
                _context2.next = 4;
                return fetch("".concat(PAY_ENDPOINT, "/checkout/").concat(uuid), request);

              case 4:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 8;
                return response.json();

              case 8:
                results = _context2.sent;
                resolve(results);
                _context2.next = 13;
                break;

              case 12:
                reject();

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                reject(_context2.t0);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 15]]);
      }));
    });
  }

  return {
    account: {
      generateCreationLink: generateAccountCreationLink
    },
    checkout: {
      find: findCheckoutByUuid,
      create: createCheckout
    }
  };
}

exports.default = pay;